import { SignalRTypes, SportTypesActionTypes } from ".";

export function initSportTypes() {
	return {
		type: SignalRTypes.SportTypes_Init,
	}
}

export function loadSportTypes(request) {
  return {
    type: SignalRTypes.SportTypes_Request,
    request,
  };
}
export function loadMainTournamentEvents(request) {
  return {
    type: SignalRTypes.Main_Tournament_Events_Request,
    request,
  };
}

export function setSport(item) {
  return {
    type: SportTypesActionTypes.Set_Sport,
    item,
  };
}

export function init() {
  return {
    type: SportTypesActionTypes.Init,
  };
}

export function removeDisabledSportTypes() {
  return {
    type: SportTypesActionTypes.SportTypes_Remove_Disabled,
  };
}

export function loadUpcomingDraws(request, addNewList) {
  return {
    type: SignalRTypes.OnUpcomingDraws,
    request,
    addNewList,
  };
}
export function getDrawsCategoriesAndTournaments(request) {
  return {
    type: SignalRTypes.Get_Draws_Categories_And_Tournaments_Request,
    request,
  };
}
export function getLuckyNumbersEventResultRequest(request, addToEvents) {
  return {
    type: SignalRTypes.Get_Lucky_Numbers_Event_Result_Request,
    request,
    addToEvents,
  };
}
export function resetUpcomingDraws() {
  return {
    type: SignalRTypes.Reset_upcoming_Draws_And_Result,
  };
}
export function getDrawOdds(request) {
  return {
    type: SignalRTypes.Get_Draw_Odds_Request,
    request,
  };
}
export function getSuggestedBalls(request) {
  return {
    type: SignalRTypes.Get_Suggested_Balls_Request,
    request,
  };
}
export function UpdateFavoriteForLuckyNumber(tournamentId) {
  return {
    type: SignalRTypes.Update_Lucky_Numbers_Favorite,
    tournamentId,
  };
}
